<template>
    <core-section id="experience">
        <core-heading>{{ $t('experience.title') }}</core-heading>
        <v-col cols="12" md="9" class="mx-auto px-0">
            <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item v-for="(item, i) in items" :key="i">
                    <span slot="opposite" v-text="item.startDate + ' - ' + item.endDate " />
                    <v-card class="pa-3">
                        <h3
                            class="subheading font-weight-bold primary--text"
                            v-text="item.company"
                        />
                        <h4 class="subheading font-weight-bold" v-text="item.position" />
                        <div class="grey--text" v-text="item.summary" />
                        <div class="link"><a v-if="item.website" :href="item.website" target="_blank">Link</a></div>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
        </v-col>
    </core-section>
</template>

<script>
export default {
    name: 'Experience',

    computed: {
        items() {
            return this.$i18n.t('experience.work');
        },
    },
};
</script>

<style lang="scss" scoped>
.link a {
    text-decoration: none;
    color: white;
}

.link a:hover {
    text-decoration: none;
    color: #ffaa00;
}
</style>
